import useAuthSettings from '@apps/www/src/www/hooks/useAuthSettings';

export default function useAuthSubscriptions() {
	const authSubscriptions = useAuthSettings(['subscriptions']);

	return authSubscriptions?.subscriptions || [];
}
